import { render, staticRenderFns } from "./DarkMode.vue?vue&type=template&id=6bf931e6&"
import script from "./DarkMode.vue?vue&type=script&lang=js&"
export * from "./DarkMode.vue?vue&type=script&lang=js&"
import style0 from "./DarkMode.vue?vue&type=style&index=0&id=6bf931e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports